import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import {
  selectStateExportCSV,
  terminateExport,
} from "app/store/trackingApp/exportCSVSlice";
import { useAppSelector, useAppDispatch } from "app/store";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import ErrorIcon from "@material-ui/icons/Error";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { useExportCsv } from "@tracking/hooks/useExportCsv";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

const useStyles = makeStyles(() => ({
  containerDownload: {
    width: "fit-content",
    bottom: 10,
    right: 10,
    borderRadius: 3,
    transition: "2s",
  },
  activeForDownload: {
    background: "#90d5ff",
  },
  notActiveForDownload: {
    background: "#fff",
  },
  textCSVDone: {
    fontSize: 13,
  },
  progressBar: {
    width: 500,
  },
}));

const initialStateError = {
  isError: false,
  errorMessage: "",
};

const formatNameCSV = (filters: any) => {
  const destructFilters: string = filters ? filters : "";
  const dateString: string = moment().format("YYYY_MM_DD-HH_mm_ss").toString();
  let name: string = `${dateString}-Pedidos-{${destructFilters}}.csv`;
  const x: string = name.split(".")[0];
  const xLength: number = x.length;
  if (xLength > 125) {
    const y = x.split(".")[0];
    const subs = y.substring(0, 125);
    name = subs + "}.csv";
  }
  return name;
};

const ExportCSVComponent = () => {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const state = useAppSelector(selectStateExportCSV);
  const {
    progress,
    buffer,
    totalPages,
    csvData,
    error,
    setCancel,
    setActiveForDownload,
    setTotalPages,
    setProgress,
    setError,
    activeForDownload,
  } = useExportCsv(state);

  const normalise = (value: number) => ((value - 0) * 100) / (totalPages - 0);

  const handleLegacy = async () => {
    try {
      const fileHandle = await window.showSaveFilePicker({
        suggestedName: state.data.nameFile
          ? state.data.nameFile
          : formatNameCSV(state.data.filters),
        types: [
          {
            description: "CSV file",
            accept: { "text/csv": [".csv"] },
          },
        ],
      });

      const fileStream = await fileHandle.createWritable();

      await fileStream.write(new Blob(["\uFEFF", csvData]));
      await fileStream.close();

      cancelExport();
    } catch (err) {
      dispatch(
        openModalError({
          title: "Falha ao salvar arquivo",
          text: "Possíveis problemas: \n - Arquivo a ser substituído está aberto em outro programa \n - Arquivo corrompido \n",
          btnLabel: "Voltar",
        })
      );
    }
  };

  const cancelExport = () => {
    setCancel(true);
    setTotalPages(100);
    setProgress(0);
    setActiveForDownload(false);
    setError(initialStateError);
    dispatch(terminateExport());
  };

  return (
    <>
      {state.activeExport && (
        <div
          className="fixed flex p-2 shadow-md bg-white"
          style={{
            width: "fit-content",
            bottom: 10,
            right: 10,
            borderRadius: 3,
            transition: "2s",
            background: activeForDownload
              ? "#90d5ff"
              : error.isError
              ? "#9a1515"
              : "#fff",
          }}
        >
          <div className="w-full leading-normal">
            {activeForDownload ? (
              <p
                onClick={handleLegacy}
                className={`cursor-pointer mb-0 font-bold text-black flex items-center gap-2 w-full h-full ${classes.textCSVDone}`}
              >
                <GetAppIcon fontSize="small" />
                <span>CSV pronto! Clique para baixar</span>
              </p>
            ) : (
              <>
                {error.isError ? (
                  <p
                    className="mb-0 font-bold text-black flex items-center gap-2 w-full h-full"
                    style={{ fontSize: 13 }}
                  >
                    <ErrorIcon fontSize="small" className="text-white" />
                    <span className="text-white">{error.errorMessage}</span>
                    <Tooltip title="Fechar exportação">
                      <IconButton onClick={cancelExport} size="small">
                        <CloseIcon fontSize="small" className="text-white" />
                      </IconButton>
                    </Tooltip>
                  </p>
                ) : (
                  <>
                    <div className="flex items-center gap-2">
                      <LinearProgress
                        className={classes.progressBar}
                        variant="buffer"
                        valueBuffer={buffer}
                        value={normalise(progress)}
                      />
                      <Tooltip title="Cancelar exportação">
                        <IconButton onClick={cancelExport} size="small">
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <small className="mb-0 font-bold text-black flex justify-between items-center">
                      {totalPages === 100 ? (
                        <span>Iniciando exportação...</span>
                      ) : (
                        <>
                          <span>Exportando CSV...</span>
                          <span>
                            {normalise(progress).toFixed(0)}% Concluído
                          </span>
                        </>
                      )}
                    </small>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ExportCSVComponent;
